module.exports = __webpack_public_path__ + "img/lb9.b2211328.svg";